import classNames from "classnames";
import styled from 'styled-components';

export const LiteTradeSelectAccountStyled = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .dropdown-toggle {
        svg {
            color: var();
        }
    }
`;

export const LiteTradeSelectAccountTitleStyled = styled.div`
    font-size: 16px;
    font-weight: 600;
`;

export const LiteTradeSelectAccountListStyled = styled.div`
    background: rgba(129, 146, 228, 0.05);
    padding: 4px;
    margin-top: 16px;
    border-radius: 16px;
`;

export const LiteTradeSelectAccountItemStyled = styled.div.attrs(({ selected }) => ({
    className: classNames({ selected })
}))`
    padding: 12px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    .account-type-icon {
        width: 32px;
        height: 32px;
        fill: var(--color-secondary-active);
        margin-right: 12px;

        background: rgba(125, 134, 178, 0.1);
        border-radius: 8px;
        padding: 4px;
        transition: all 500ms;
    }

    span {
        display: inline-block;
    }

    &:hover,
    &.selected {
        background: rgba(129, 146, 228, 0.1);
        border-radius: 12px;
        color: var(--color-white);

        .account-type-icon {
            fill: var(--color-yellow);
            background: rgba(255, 221, 60, 0.2);
        }
    }
    
    .top-up-button {
        margin-left: 12px;
        padding: 8px 12px 8px 8px;
        
        svg {
            fill: var(--color-white-95);
        }
    }
`;

export const SelectAccountToggleStyled = styled.div.attrs(({ type }) => ({
    className: type
}))`
    width: 100%;
    .select-toggle {
        padding: 8px 36px 8px 12px;
        background: rgba(129, 146, 228, 0.1);
        border-radius: 16px;
        color: var(--color-secondary);
        border: none;
        line-height: 24px;

        &:hover {
            border-color: transparent;
        }
        
        .right-icon {
            right: 12px;
            font-size: 12px;

            svg {
                fill: var(--color-secondary);
            }
        }
    }

    .icon svg {
        width: 32px;
        height: 32px;
        fill: var(--color-surface);
        margin-right: 12px;

        background: var(--color-yellow);
        border-radius: 12px;
        padding: 4px;
    }

    &.demo {
        .select-toggle {
            padding: 4px 36px 4px 4px;
            color: var(--color-yellow);

            .right-icon {
                svg {
                    fill: var(--color-yellow);
                }
            }
        }
    }
`;

export const SelectAccountToggleRowStyled = styled.div`
    flex: 1;
    display: flex;
    justify-content: space-between;
    
    .value {
        color: #FFFFFF;
        font-weight: 600;
    }
`;

export const LiteTradeSelectAccountItemBalanceStyled = styled.div`
    font-size: 16px;
    font-weight: 600;
`;

export const LiteTradeSelectAccountInfoStyled = styled.div`
    display: flex;
    align-items: center;
    padding-left: 20px;
    margin: 16px 0 40px;
`;

export const LiteTradeSelectAccountInfoDescriptionStyled = styled.div`
    color: var(--icon-primary-color);
    font-size: 12px;
`;
